export enum MaintenanceType {
  BASIC = 'basic',
  SOFT_MAINTENANCE = 'soft-maintenance'
}
